//import React, { useEffect } from "react";
import { Button } from "../../../common/Button/Button";
//import Checkbox from "../../../common/Checkbox/Checkbox";
import { useEffect, useRef } from "react";
import select_arrow_down from "./../../../assets/select_arrow_down.svg";
import group from "./../../../assets/group.svg";
//import ColumnSectionDropdown from "../Admin/ColumnSelectionDropdown";
import ShowMoreDropdown from "../Admin/ShowMoreDropdown";
import close_modal from "./../../../assets/ic_close_wh.svg";
import UserFacilitatorFeedbackModal from "./UserFacilitatorFeedbackModal";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../../common/Pagination/Pagination";
import { getServiceTypesMaster, getUser } from "../../../utils/localStorage";
import find from "lodash/find";
import moment from "moment";
import NeftModal from "../Handholder/NeftModal";
//import NotesFacilitatorViewModal from "./NotesFacilitatorViewModal";
//import NotesServiceFacilitatorViewModal from "./NotesServiceFacilitatorViewModel";
import NotesServiceFacilitatorModal from "./NotesServiceFacilitatorModel";
import AssignServicePartnerModal from "./AssignServicePartnerModal";
//import AssignExternalServicePartnerModal from "./AssignExternalServicePartnerModal";
import AssignExternalServicePartnerModalNew from "./AssignExternalServicePartnerModalNew";
import copysvg from "./../../../assets/arrow_copy.svg";
import copysvg1 from "./../../../assets/arrow_copy_light.svg";
import profilesvg from "./../../../assets/profile.svg";
import arrow_down from "./../../../assets/arrow_down.svg";
import { toast } from "react-toastify";
import ConfirmationModal from "./ConfirmationModal";
//import StateChangeModalSPM from "./StateChangeModalSPM";
import StateServiceChangeModalSPM from "./StateServiceChangeModalSPM";
import StateChangeLogModalSPM from "./StateChangeLogModalSPM";
import StateAuditLogDropdown from "./StateAuditLogDropdown";
import { URL_CALCULATOR } from "../../../utils/urls";
import { useState } from "react";
import { DND_LINK } from "../../../utils/constants";
import CancellationReasonModal from "../Handholder/CancellationReasonModal";
import Spinner from "../../../common/Spinner/Spinner";
import "../../../styles/tablecss.css"
import { ExportCSV } from "./ExportCSV";
import Select from "react-select";
import api from "../../../utils/api";
import axios from "axios";
const ReactTableFixedColumns = withFixedColumns(ReactTable);
// Modal.setAppElement("#root");



//import { color } from "html2canvas/dist/types/css/types/color";


export default function FacilitatorServiceTable(props) {



    // const [columnPage,setcolumnPage] =useState(0);
    // const [selectedColumnsCount,setSelectedColumnCount] =useState(0)

    const [ExpertPartner, setExpertPartner] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState()
    const [slotData, setSlotData] = useState()
    const [timing, setTiming] = useState([])
    const [id, setId] = useState()
    const ExpertName = localStorage.getItem("Resource")
    const [bookSlotTime, setBookSlotTime] = useState('')
    const [bookSlotDay, setBookSlotDay] = useState('')
    const [bookSlotDate, setBookSlotDate] = useState('')
    const [expanded, setExpanded] = useState({})
    const [newServiceRequestId, setNewServiceRequestId] = useState()

    var CurrentDate = new Date().toLocaleDateString('en-CA')
    let timeRN = moment(new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),'hh:mm A').format('HH:mm')

    


    useEffect(() => {
        ExpertCalenderData()
        ExpertAppointmentData()
        console.log("PROPS==", props)
        // getDatabyID()

        // setTimeout(() => {

        //     filterData()
        // }, 2000);
    }, [])

    
    const [colData, setColData] = useState()

    useEffect(() => {
        if(props.data){
            setColData(props.data)
        }
    }, [props])

    if(colData && colData[0]?.dtServiceProgression){
        colData.sort((a,b)=> {
            return a?.dtServiceProgression < b?.dtServiceProgression ? 1 : -1
        })
    }
    
    

    useEffect(() => {
        // getDatabyID()
        if (ExpertPartner) {
            ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? setId(ele.refExternalServicePartner_id) : ""))
            console.log("useEffectID", id)
        }
        setTimeout(() => {
            if (id) {
                // axios.get(`https://stagewebadmin.deasra.in:8050/server/get-expert-calender/${id}/`, {
                //     headers: {
                //         Authorization: "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
                //     }
                // })
                api.getExpertById(id)
                    .then((res) => {
                        // alert(res.data)
                        setData(res.data)
                    })
            }
        }, 500);
    }, [id])

    let ExpertID = ""

    if (ExpertPartner) {
        console.log("POuter", ExpertPartner)
        ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? ExpertID = ele.refExternalServicePartner_id : ""))
    }

    console.log("AAAA", ExpertID)

    const getDatabyID = () => {
        setId(ExpertID)
        //     // let ExpertName = localStorage.getItem("Resource")
        //     // let newID = ""
        //     if(ExpertPartner){
        //         // console.log("POuter", ExpertPartner)
        //        ExpertPartner.filter((ele) => ((ele.refExternalServicePartner === ExpertName) ? setId(ele.refExternalServicePartner_id): ""))   
        //     }
        // //     console.log("FROM OUTER FUNCTION", id)
        //     if(id){
        //     axios.get(`https://stagewebadmin.deasra.in:8050/server/get-expert-calender/${id}/`, {headers: {
        //         Authorization : "Token 11c2e5f0fc3aa6e71c5c5fc5211bd3ce692829a3"
        //     }}).then((res) => {
        //         // alert(res.data)
        //         setData(res.data)
        //     })
        // }
    }

    const ExpertAppointmentData = () => {
        api.getAllExpertAppointmentList().then(({ data }) => {
            console.log("Appointments", data)
            setSlotData(data.reverse())
        })
    }

    const [AppData, setAppData]= useState()
    const [isSlot, setIsSlot] = useState(false)

    // let AppData;
    let MainData;

    if (slotData) {
        MainData = slotData.filter((ele) => ele.bookdate >= new Date().toLocaleDateString('en-CA'))
        // AppData = MainData.find((ele) => ele.nResourceInstanceId === ResourceId)
    }
    console.log("AppoDTat", MainData)
    let bookTime;

    const getBookedSlot = (serviceID) => {
        setAppData(MainData.find((ele) => ele.nResourceInstanceId === serviceID && ele.status != "Deleted"))
        if(AppData){
            let newTime = AppData.slot_time.split("-")
        let newTime1 = newTime[0]
        let ampm = newTime[1].split(" ")[1]
        let result = `${newTime1} ${ampm}`
        bookTime = moment(result, 'hh:mm A').format('HH:mm')
        console.log("Booktime",bookTime)
        }
        
        console.log("getBookedSlot", AppData)
        console.log("Result===", bookTime)
    }

    useEffect(() => {
        if(AppData){
            getBookedSlot(ResourceId)
        }
        
    }, [slotData])
    
    // let timeRN;
    // let bookTime;
    // if(AppData != undefined) {
    //     let newTime = AppData.slot_time.split("-")
    //     console.log("NewTime",newTime)
    // let newTime1 = newTime[0]
    // let ampm = newTime[1].split(" ")[1]

    // let result = `${newTime1} ${ampm}`
    //  bookTime = moment(result, 'hh:mm A').format('HH:mm')
    // console.log(bookTime)
    //  timeRN = moment(new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),'hh:mm A').format('HH:mm')
    // }

    // console.log(bookTime, timeRN)

    // if(AppData != undefined && AppData.status === null){
    //     let newTime = AppData.slot_time.split("-")
    //     let newTime1 = newTime[0]
    //     let ampm = newTime[1].split(" ")[1]
    //     let result = `${newTime1} ${ampm}`
    //     console.log("Result",result)
    //     if(result === "11:00 PM"){
    //         bookTime = "11:00"
    //     } else {
    //         bookTime = moment(result, 'hh:mm A').format('HH:mm')
    //     }
    //     console.log("Booktime",bookTime)
    // }


    // getVerifiedStatus
    // const [verified, setVerified] = useState('')

    // const verifiedStatus = (e) => {
    //     console.log("EEEEE", e)
    //     setVerified('')
    //     if (e.sServiceCode === "DEPRELISTING") {
    //         let payload = {
    //             api_key: '82mqEyJnct4kzC8y',
    //             resource_instance_id: e.nResourceInstanceId
    //         }
    //         api.getVerifiedStatus(payload).then(({data}) => {
    //             console.log("PAYOAD==", data.data)
    //                 if (data.ErrorCode === 200) {
    //                     setVerified(data.data.status)
    //                 }
    //         })
    //     }
    // }

    const deleteAppointment = () => {
        if(AppData != undefined && AppData.status === null){
            console.log("ID+++",AppData.id)
            let payload ={
                id:AppData.id
            }
            api.deleteExpertAppointment(payload)
            .then(({data}) => {
                // setIsSlot(true)
                ExpertAppointmentData()
                console.log("Deleted",data)
                if(data === "Appointment Deleted Successfully."){
                    toast("Appointment Deleted Successfully.", {
                        type: toast.TYPE.SUCCESS
                    })
                }
            })
        }

        
    }


    const ExpertCalenderData = () => {
        console.log("dsfsd", data)
        api.getAllExpertCalenderList().then(({ data }) => {
            console.log("Data", data)
            setExpertPartner(data)
        })
    }

    let arr = []

    console.log("ExpertData==", ExpertPartner)

    if (ExpertPartner) {
        ExpertPartner.map((ele) => {
            arr.push(ele.refExternalServicePartner)
        })
    }

    console.log("ARRRAAAYYY", arr)

    if (arr.includes(ExpertName)) {
        console.log("yeeeeeeeeeeeeeeeeeeeeeeeeeeeeeey")
    }

    const copyToClipboard = (content) => {
        const el = document.createElement('textarea');
        el.value = content;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };


    const [startDate, setStartDate] = useState(new Date());
    const dayNum = startDate.getDay()
    let day;
    if (dayNum === 0) {
        day = "Sunday"
    } else if (dayNum === 1) {
        day = "Monday"
    } else if (dayNum === 2) {
        day = "Tuesday"
    } else if (dayNum === 3) {
        day = "Wednesday"
    } else if (dayNum === 4) {
        day = "Thursday"
    } else if (dayNum === 5) {
        day = "Friday"
    } else {
        day = "Saturday"
    }
    console.log("Day=", day)
    console.log("New Day=", startDate)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [newModal, setNewModal] = useState(false)

    const [commentsText, setCommentsText] = useState("")
    const [payloadDate, setPayloadDate] = useState("")




    console.log("Comments", commentsText)

    const array = [
        {
            value: '11:00-12:00 pm', label: '11:00 am - 12:00 pm'
        },
        {
            value: '12:00-12:00 pm', label: '12:00 am - 12:00 pm'
        }, {
            value: '13:00-12:00 pm', label: '13:00 am - 12:00 pm'
        }, {
            value: '14:00-12:00 pm', label: '14:00 am - 12:00 pm'
        }, {
            value: '10:00-12:00 pm', label: '15:00 am - 12:00 pm'
        },
    ]


    const bookExpert = () => {
        if (expertTime === "") {
            toast("Expert Not Available for the Following Slot.", {
                type: toast.TYPE.ERROR,
            });
        } else {
            let payload;
            let CurrentDate = new Date()
            var getYear = CurrentDate.toLocaleString("default", { year: "numeric" });
            var getMonth = CurrentDate.toLocaleString("default", { month: "2-digit" });
            var getDay = CurrentDate.toLocaleString("default", { day: "2-digit" });
            var CurrDate1 = getYear + "-" + getMonth + "-" + getDay;
            if (payloadDate) {
                payload = {
                    nResourceInstanceId: ResourceId,
                    comments: commentsText,
                    expert_id: ExpertID,
                    slot_time: expertTime,
                    slot_day: day,
                    bookdate: payloadDate
                }
            } else {
                payload = {
                    nResourceInstanceId: ResourceId,
                    comments: commentsText,
                    expert_id: ExpertID,
                    slot_time: expertTime,
                    slot_day: day,
                    bookdate: CurrDate1
                }
            }
            api.bookExpertAppointment(payload).then(res => {
                setExpertTime("")
                // setExpertDay('')
                // setCommentsText('')
                // setStartDate(new Date)


                if (res.data.message === "Expert Appointment Updated Successfully.") {
                    toast("Expert Appointment Updated Successfully.", {
                        type: toast.TYPE.SUCCESS,

                    });
                    setTimeout(() => {
                        setModalIsOpenToFalse()
                    }, 1000)
                    setExpertTime('')
                    setExpertDay('')
                    setCommentsText('')
                    setStartDate(new Date())
                    localStorage.removeItem("Resource")
                    setBookSlotDay(day)
                    setBookSlotTime(expertTime)
                    setBookSlotDate(payloadDate ? payloadDate : new Date().toLocaleDateString('en-CA'))
                    // getBookedSlot(ResourceId)
                    ExpertAppointmentData()
                    setIsSlot(true)
                } else {
                    toast("Appointment slot is unavailable .", {
                        type: toast.TYPE.ERROR,
                    });
                    // setExpertTime("")
                    // setTimeout(() => {
                    //     setModalIsOpenToFalse()
                    // }, 1000)
                }
            })
        }
    }

    const openCalenderModalIsTrue = () => {
        setNewModal(true)
    }

    const openCalenderModalIsFalse = () => {
        setNewModal(false)
    }

    const setModalIsOpenToTrue = () => {
        setModalIsOpen(true)
    }

    const setModalIsOpenToFalse = () => {
        setModalIsOpen(false)
    }

    // Auto refresh State change modal
    
    // let Interval;

    // useEffect(() => {
    //     if (props.selectedServiceRequest) {
    //         const { nResourceInstanceId } = props.selectedServiceRequest;
    //         Interval = setInterval(() => {
    //             props.updateStatusArray(nResourceInstanceId);
    //         }, 10000);
    //         return () => clearInterval(Interval);
    //     }
    // }, [props.selectedServiceRequest])

    const toggleStatusChangeModalOld = (e) => {
        if (e.nResourceInstanceId) props.onSelectServiceRequest(e);
        else props.onSelectServiceRequest(null);
        setShowStatusChangeModal(!showStatusChangeModal);

        // if (setShowStatusChangeModal === false) {
        //     clearInterval(Interval)
        // }

    };
    const toggleStatusChangeModal = async (e) => {
        if (!e?.nResourceInstanceId) {
            props.onSelectServiceRequest(null);
            setShowStatusChangeModal(false);
            return;
        }
    
        try {
            await props.updateStatusArray(e.nResourceInstanceId);
            setShowStatusChangeModal(true);
        } catch (error) {
            console.error("Failed to update status array", error);
        }
    };
    const [showStatusChangeLogModal, setShowStatusChangeLogModal] = useState(
        false
    );
    const [showAppointmemtModal, setShowAppointmentModal] = useState(false)
    const toggleStatusChangeLogModal = (e) => {
        if (e.nResourceInstanceId) props.onSelectServiceRequest(e);
        else props.onSelectServiceRequest(null);
        setShowStatusChangeLogModal(!showStatusChangeLogModal);
    };
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false);

    const toggleConfirmationModal = () => {
        setShowConfirmationModal(!showConfirmationModal);
    };
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState({});
    const handleClick = (f, e) => {
        if (f.target.name !== undefined) {
            if (f.target.name === "cancelled") {
                props.toggleCancellationReasonModal();
                setSelectedStatus({ statusName: f.target.name, service: e });
            } else {
                toggleConfirmationModal();
                // toggleStatusChangeModal();
                setSelectedStatus({ statusName: f.target.name, service: e });
            }
        }
    };
    const changeState = () => {
        props.changeState(selectedStatus);
        if(selectedStatus.statusName === "cancelled"){
            if(AppData?.bookdate > CurrentDate || (AppData?.bookdate === CurrentDate && bookTime > timeRN)){
                deleteAppointment()
            }
        }
        if (selectedStatus.statusName !== "cancelled")
            toggleConfirmationModal();
        
    };

    
        



    function getReCalculateURL(
        sServiceState,
        paymentMode,
        nResourceInstanceId,
        catalogId
    ) {
        let pricingAndProcessingMode = props.allCatalogs.filter(
            (e) => e["sCatalogueId"] === catalogId
        );
        let isDynamic = false;
        if (
            pricingAndProcessingMode.length > 0 &&
            pricingAndProcessingMode[0]["sMode"].split("_")[0] !== "DYNAMIC"
        ) {
            isDynamic = true;
        }
        if (
            sServiceState === "Full Payment Received" ||
            sServiceState === "Delivered" ||
            paymentMode !== "2_Step_Payment" ||
            isDynamic
        ) {
            return null;
        } else {
            return URL_CALCULATOR + String(nResourceInstanceId);
        }
    }
    function getReCalculateURLClassName(sServiceState, paymentMode, catalogId) {
        let pricingAndProcessingMode = props.allCatalogs.filter(
            (e) => e["sCatalogueId"] === catalogId
        );
        let isDynamic = false;
        if (
            pricingAndProcessingMode.length > 0 &&
            pricingAndProcessingMode[0]["sMode"].split("_")[0] !== "DYNAMIC"
        ) {
            isDynamic = true;
        }
        if (
            sServiceState === "Full Payment Received" ||
            sServiceState === "Delivered" ||
            paymentMode !== "2_Step_Payment" ||
            isDynamic
        ) {
            return "disableLink";
        } else {
            return "";
        }
    }



    console.log("sedfsfsf", ExpertPartner)

    //     const filterData = () => {
    //         console.log("from pouter func")


    // }




    // ExpertPartner.filter((ele) => ((ele.refExternalServicePartner).toLowerCase() === (ExpertName).toLowerCase() ? console.log("ExpertIDDD ===",ele.refExternalServicePartner_id) : ""))


    const openAppointmentModal = () => {
        setModalIsOpenToTrue()
    }


    const user = getUser();
    const getServiceName = (original) => {
        if (!original) return;
        const found = find(getServiceTypesMaster(), {
            sServiceCode: original.sServiceCode,
        });
        if (found) {
            return found.sServiceName;
        }
        return "";
    };
    const NoDataComponent = (p) => {
        return <div>No data</div>;
    };



    const [expertTime, setExpertTime] = useState("")
    useEffect(() => {
        console.log('ExpertTime==', expertTime)
    }, [expertTime])

    const [expertDay, setExpertDay] = useState("")
    console.log('ExpertDAy==', expertDay)



    let timeSlot = [];

    if (data) {
        console.log("GK==", data)
        data.filter((ele) => (ele.day === day) ? timeSlot.push(ele.time) : "");
    }


    console.log("Prasad Time", timeSlot)


    // const ExpertPartner = [
    //     {
    //         "id": 13,
    //         "calender_slots": [
    //             {
    //                 "time": "05:00-06:00 PM",
    //                 "day": "Thursday"
    //             },
    //             {
    //                 "time": "11:00-12:00 PM",
    //                 "day": "Tuesday"
    //             },
    //             {
    //                 "time": "10:00-11:00 AM",
    //                 "day": "Monday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 2,
    //         "refExternalServicePartner": "Jugal Doshi"
    //     },
    //     {
    //         "id": 3,
    //         "calender_slots": [
    //             {
    //                 "time": "02:00-03:00 PM",
    //                 "day": "Monday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 1,
    //         "refExternalServicePartner": "Gaurav Kulkarni"
    //     },
    //     {
    //         "id": 12,
    //         "calender_slots": [
    //             {
    //                 "time": "02:00-03:00 PM",
    //                 "day": "Wednesday"
    //             },
    //             {
    //                 "time": "02:00-03:00 PM",
    //                 "day": "Monday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 4,
    //         "refExternalServicePartner": "Shriram Kulkarni"
    //     },
    //     {
    //         "id": 5,
    //         "calender_slots": [
    //             {
    //                 "time": "04:00-05:00 PM",
    //                 "day": "Friday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 6,
    //         "refExternalServicePartner": "Chittlesoft"
    //     },
    //     {
    //         "id": 6,
    //         "calender_slots": [
    //             {
    //                 "time": "05:00-06:00 PM",
    //                 "day": "Monday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 7,
    //         "refExternalServicePartner": "Prasad Mahalungkar"
    //     },
    //     {
    //         "id": 11,
    //         "calender_slots": [
    //             {
    //                 "time": "03:00-04:00 PM",
    //                 "day": "Thursday"
    //             },
    //             {
    //                 "time": "03:00-04:00 PM",
    //                 "day": "Monday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 83,
    //         "refExternalServicePartner": "Parag Sane"
    //     },
    //     {
    //         "id": 14,
    //         "calender_slots": [
    //             {
    //                 "time": "02:00-03:00 PM",
    //                 "day": "Wednesday"
    //             },
    //             {
    //                 "time": "12:00-01:00 PM",
    //                 "day": "Wednesday"
    //             },
    //             {
    //                 "time": "01:00-02:00 PM",
    //                 "day": "Friday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 5,
    //         "refExternalServicePartner": "Prachi Kulkarni"
    //     },
    //     {
    //         "id": 9,
    //         "calender_slots": [
    //             {
    //                 "time": "12:00-01:00 PM",
    //                 "day": "Friday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 16,
    //         "refExternalServicePartner": "Self served"
    //     },
    //     {
    //         "id": 17,
    //         "calender_slots": [
    //             {
    //                 "time": "02:00-03:00 PM",
    //                 "day": "Wednesday"
    //             },
    //             {
    //                 "time": "12:00-01:00 PM",
    //                 "day": "Tuesday"
    //             },
    //             {
    //                 "time": "10:00-11:00 AM",
    //                 "day": "Monday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 18,
    //         "refExternalServicePartner": "Sumedha Jalgaonkar"
    //     },
    //     {
    //         "id": 23,
    //         "calender_slots": [
    //             {
    //                 "time": "05:00-06:00 PM",
    //                 "day": "Friday"
    //             },
    //             {
    //                 "time": "02:00-03:00 PM",
    //                 "day": "Thursday"
    //             },
    //             {
    //                 "time": "01:00-02:00 PM",
    //                 "day": "Thursday"
    //             },
    //             {
    //                 "time": "12:00-01:00 PM",
    //                 "day": "Wednesday"
    //             },
    //             {
    //                 "time": "11:00-12:00 PM",
    //                 "day": "Tuesday"
    //             },
    //             {
    //                 "time": "10:00-11:00 AM",
    //                 "day": "Monday"
    //             }
    //         ],
    //         "refExternalServicePartner_id": 8,
    //         "refExternalServicePartner": "Prasad Kendre"
    //     }
    // ]

    // const ExpertPartner = [
    //     {
    //         "id": 1,
    //         "refExternalServicePartner": "Jugal Doshi",
    //         "time": "10:00-11:00 AM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 2,
    //         "refExternalServicePartner": "Jugal Doshi",
    //         "time": "11:00-12:00 PM",
    //         "day": "Tuesday"
    //     },
    //     {
    //         "id": 3,
    //         "refExternalServicePartner": "Gaurav Kulkarni",
    //         "time": "02:00-03:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 4,
    //         "refExternalServicePartner": "Shriram Kulkarni",
    //         "time": "02:00-03:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 5,
    //         "refExternalServicePartner": "Chittlesoft",
    //         "time": "04:00-05:00 PM",
    //         "day": "Friday"
    //     },
    //     {
    //         "id": 6,
    //         "refExternalServicePartner": "Prasad Mahalungkar",
    //         "time": "05:00-06:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 7,
    //         "refExternalServicePartner": "Parag Sane",
    //         "time": "03:00-04:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 8,
    //         "refExternalServicePartner": "Prachi Kulkarni",
    //         "time": "01:00-02:00 PM",
    //         "day": "Friday"
    //     },
    //     {
    //         "id": 9,
    //         "refExternalServicePartner": "Self served",
    //         "time": "12:00-01:00 PM",
    //         "day": "Friday"
    //     },
    //     {
    //         "id": 10,
    //         "refExternalServicePartner": "Prachi Kulkarni",
    //         "time": "12:00-01:00 PM",
    //         "day": "Wednesday"
    //     },
    //     {
    //         "id": 11,
    //         "refExternalServicePartner": "Parag Sane",
    //         "time": "03:00-04:00 PM",
    //         "day": "Thursday"
    //     },
    //     {
    //         "id": 12,
    //         "refExternalServicePartner": "Shriram Kulkarni",
    //         "time": "02:00-03:00 PM",
    //         "day": "Wednesday"
    //     },
    //     {
    //         "id": 13,
    //         "refExternalServicePartner": "Jugal Doshi",
    //         "time": "05:00-06:00 PM",
    //         "day": "Thursday"
    //     },
    //     {
    //         "id": 14,
    //         "refExternalServicePartner": "Prachi Kulkarni",
    //         "time": "02:00-03:00 PM",
    //         "day": "Wednesday"
    //     },
    //     {
    //         "id": 15,
    //         "refExternalServicePartner": "Sumedha Jalgaonkar",
    //         "time": "10:00-11:00 AM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 16,
    //         "refExternalServicePartner": "Sumedha Jalgaonkar",
    //         "time": "12:00-01:00 PM",
    //         "day": "Tuesday"
    //     },
    //     {
    //         "id": 17,
    //         "refExternalServicePartner": "Sumedha Jalgaonkar",
    //         "time": "02:00-03:00 PM",
    //         "day": "Wednesday"
    //     },
    //     {
    //         "id": 18,
    //         "refExternalServicePartner": "Prasad Kendre",
    //         "time": "10:00-11:00 AM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 19,
    //         "refExternalServicePartner": "Prasad Kendre",
    //         "time": "11:00-12:00 PM",
    //         "day": "Tuesday"
    //     },
    //     {
    //         "id": 20,
    //         "refExternalServicePartner": "Prasad Kendre",
    //         "time": "12:00-01:00 PM",
    //         "day": "Wednesday"
    //     },
    //     {
    //         "id": 21,
    //         "refExternalServicePartner": "Prasad Kendre",
    //         "time": "01:00-02:00 PM",
    //         "day": "Thursday"
    //     },
    //     {
    //         "id": 22,
    //         "refExternalServicePartner": "Prasad Kendre",
    //         "time": "02:00-03:00 PM",
    //         "day": "Thursday"
    //     },
    //     {
    //         "id": 23,
    //         "refExternalServicePartner": "Prasad Kendre",
    //         "time": "05:00-06:00 PM",
    //         "day": "Friday"
    //     }
    // ]



    // let a=[]
    // let b=[]
    // let c=[]
    // let d=[]
    // let e=[]
    // let f=[]
    // let g=[]
    // let h=[]
    // let i=[]
    // let j=[]

    // console.log(ExpertPartner.map((ele) => {
    //     // console.log(ele)
    //     if (ele.refExternalServicePartner === "Prasad Kendre") {
    //     a.push(ele);
    //     }
    //     if(ele.refExternalServicePartner==="Sumedha Jalgaonkar"){
    //     b.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Prachi Kulkarni"){
    //     c.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Jugal Doshi"){
    //     d.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Shriram Kulkarni"){
    //     e.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Parag Sane"){
    //     f.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Self served"){
    //     g.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Gaurav Kulkarni"){
    //     h.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Prasad Mahalungkar"){
    //     i.push(ele)
    //     }
    //     if(ele.refExternalServicePartner==="Chittlesof"){
    //     j.push(ele)
    //     }


    //     }))

    // const data = [
    //     {
    //         "id": 29,
    //         "refExternalServicePartner_id": 66,
    //         "refExternalServicePartner": "Mr. Sudhir Gijare",
    //         "time": "11:00-12:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 30,
    //         "refExternalServicePartner_id": 66,
    //         "refExternalServicePartner": "Mr. Sudhir Gijare",
    //         "time": "03:00-04:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 31,
    //         "refExternalServicePartner_id": 66,
    //         "refExternalServicePartner": "Mr. Sudhir Gijare",
    //         "time": "04:00-05:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 32,
    //         "refExternalServicePartner_id": 66,
    //         "refExternalServicePartner": "Mr. Sudhir Gijare",
    //         "time": "05:00-06:00 PM",
    //         "day": "Monday"
    //     },
    //     {
    //         "id": 33,
    //         "refExternalServicePartner_id": 66,
    //         "refExternalServicePartner": "Mr. Sudhir Gijare",
    //         "time": "10:00-11:00 AM",
    //         "day": "Tuesday"
    //     }
    // ]

    // console.log("list", a)




    // for (let i = 0; i<11; i++ ){
    //     // if(ExpertPartner[i].refExternalServicePartner === "Shriram Kulkarni") {
    //     //     console.log(ExpertPartner[i].time)
    //     // }
    //     console.log(ExpertPartner[i])
    //     if(ExpertPartner[i].refExternalServicePartner === "Prachi Kulkarni"){
    //        setExpertTime(ExpertPartner[i].time)
    //     }
    // }


    // const ExpertSlot = ExpertPartner[0].time
    // console.log(ExpertSlot)
    // const generateColumns=()=>{

    // 	let selectedColumnCount =0;
    // 	let currentCount =0;
    // 	let colPage=columnPage;

    const ResourceId = localStorage.getItem("InstanceID")
    console.log("nresourceID", ResourceId)

    // console.log("Match", ExpertPartner.refExternalServicePartner)



    const expertColumns = [
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            Header: "Expert Names",
            accessor: "refExternalServicePartner",
            style: { 'whiteSpace': 'unset' },
            // width: 100,
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Monday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Monday" ? <div> {ele.time} </div> : ""
                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Tuesday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Tuesday" ? <div> {ele.time} </div> : ""

                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Wednesday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                // let a = []
                                // a.push(ele.time)
                                // console.log("NEWWWWW",a)
                                return ele.day === "Wednesday" ? <div> {ele.time} </div> : ""
                            }
                            )
                        }</span>


                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Thursday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Thursday" ? <div> {ele.time} </div> : ""

                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        {
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Friday",
            accessor: "calender_slots",
            Cell: ({ original }) => (
                <>
                    <span>
                        {
                            original.calender_slots.map((ele) => {
                                {
                                    return ele.day === "Friday" ? <div> {ele.time} </div> : ""

                                }
                                // return ele.day 



                            }
                            )
                        }</span>
                    {/* <span>{original["calen"]}</span> */}
                </>
            )
        },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Tuesday",
        //     accessor: "calender_slots",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Wednesday",
        //     accessor: "calender_slots.day",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Thursday",
        //     accessor: "calender_slots.time",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Friday",
        //     accessor: "calender_slots.time",
        // },
        // {
        //     headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '10%' },
        //     style: { 'whiteSpace': 'unset' },
        //     Header: "Slots Available",
        //     accessor: "time",
        // }

    ]



    const columns = [
        {
            id: "sServiceCode",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            Header: "User Profile Icon",
            accessor: "sServiceCode",
            style: { 'whiteSpace': 'unset' },
            width: 80,
            //height:10,

            Cell: ({ original }) =>
            (
                <>


                    <img
                        //alt="copy"
                        src={profilesvg}
                        className="ellipse"
                        onClick={(e) => {
                            props.toggleUserProfileModal(e, original);
                            props.setExpandedChange(this)
                        }}
                    // e.preventDefault();
                    // copyToClipboard(original.nResourceInstanceId);
                    //<a href="#" onClick={(e) => props.toggleUserProfileModal(e, original)} target="_self"></a>

                    />

                </>
            )

        },



        {
            id: "sServiceCode",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '20%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Service Name + Service ID",
            accessor: "sServiceCode",
            //width: 150,
            // height:10,
            Cell: ({ original }) =>
            (
                <>
                    <span>
                        {(original.sServiceCode === "MKTLINKAGEEXHIBITION" || original.sServiceCode === "MKTLINKAGEBULKBUYER" ||
											original.sServiceCode === "MKTLINKAGEECOM" ||original.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
											original.sServiceCode === "MKTLINKAGESHOPINSHOP" ||original.sServiceCode === "MKTLINKAGEEXPORT")  && original.sServiceDisplayName ?
                    getServiceName(original) + " " + `(${original.sServiceDisplayName})`
                                            :
                    getServiceName(original)
                    }
                    </span>
                    <br></br>

                    <br></br>
                    <span>ID: {original["nResourceInstanceId"]}</span>

                </>
            )
        },


        {
            id: "sServiceCode",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '10%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Package Details",
            accessor: "sServiceCode",
            //width: 150,
            //height:10,
            Cell: ({ original }) =>
            (
                <>
                    <span>{original["sPackageOfferTitle"] ? original["sPackageOfferTitle"] : ""}</span>
                    <br></br>

                    <br></br>
                    <span>{original["nPackageInstanceId"] ?
                        (
                            `ID: ${original["nPackageInstanceId"]}`) : ""}
                    </span>

                </>
            )
        },


        {
            id: "nResourceInstanceId",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '10%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Customer Name + Status Details",
            accessor: "nResourceInstanceId",
            //width: 150,
            //height:10,
            Cell: ({ original }) =>
                original["customer_meta"] ? (
                    <>
                        <span>
                            {original["customer_meta"]["first_name"]}{" "}
                            {original["customer_meta"]["last_name"]}
                        </span>
                        <br></br>
                        <a
                            style={{ textDecoration: "underline" }}
                            onClick={() => {
                                toggleStatusChangeModal(original);
                            }}
                        >
                            {/* {" "}Status Delivery Start{" "} */}
                            <span className="label-link">{" "}{original["refCurrentState"]["sServiceState"]}{" "}</span>
                        </a>
                    </>
                ) : (
                    <span></span>
                ),
        },



        {
            id: "nResourceInstanceId",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '30%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Customer Details",
            accessor: "nResourceInstanceId",

            //height:10,
            Cell: ({ original }) =>
            (
                <>
                    <div className={"conv-float-left"}>
                        <div>
                            <span className="conv-float-left conv-mr18 lpm-service-grid-key"></span>
                            {
                                original.sEmailAddress ?
                                    (
                                        <>
                                            <img
                                                alt="copy"
                                                src={copysvg}
                                                height={"20px"}
                                                width={"16px"}
                                                className="con-cursor-pointer conv-mr10 "
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    copyToClipboard(original.sEmailAddress);
                                                    toast(`${original.sFirstName ?
                                                        original.sFirstName :
                                                        ""
                                                        }${' '}
                                                        ${original.sLastName ?
                                                            original.sLastName :
                                                            ""
                                                        }'s Email Copied!`, {
                                                        autoClose: 5000,
                                                        type: toast.TYPE.SUCCESS,
                                                    });
                                                }}
                                            />
                                            <span className="lpm-service-grid-value" style={{ wordBreak: "break-all", width: "152px" }}>

                                                {
                                                    original.sEmailAddress
                                                }
                                            </span><br></br>
                                        </>
                                    )
                                    :
                                    ("NA")
                            }
                        </div>
                        <div style={{ "clear": "both" }}></div>
                        <div className="conv-mt10">
                            <span className="conv-float-left conv-mr5 lpm-service-grid-key"></span>
                            {
                                original.sContactNumber ?
                                    (
                                        <>
                                            <img
                                                alt="copy"
                                                src={copysvg}
                                                height={"20px"}
                                                width={"16px"}
                                                className="con-cursor-pointer conv-mr10"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    copyToClipboard(original.sContactNumber);
                                                    toast(`${original.sFirstName ?
                                                        original.sFirstName :
                                                        ""
                                                        }${' '}
                                                        ${original.sLastName ?
                                                            original.sLastName :
                                                            ""
                                                        }'s Contact Copied!`, {
                                                        autoClose: 5000,
                                                        type: toast.TYPE.SUCCESS,
                                                    });
                                                }}
                                            />
                                            <span className="lpm-service-grid-value" style={{ wordBreak: "break-all", width: "135px" }}>
                                                {
                                                    original.sContactNumber
                                                }
                                            </span>
                                        </>
                                    )
                                    :
                                    ("")
                            }
                        </div>
                    </div>
                </>
            )
        },


        {
            id: "refExternalServicePartner",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc', 'width': '30%' },
            style: { 'whiteSpace': 'unset' },
            Header: "Ex Service Partner",
            accessor: "refExternalServicePartner",
            // width: 250,
            // height:10,
            Cell: ({ original }) =>
            (
                <>
                    <span>
                        {original["refExternalServicePartner"] && (
                            <>
                                {original["refExternalServicePartner"][
                                    "sName"
                                ] &&
                                    original["refExternalServicePartner"][
                                    "sName"
                                    ]}
                            </>
                        )}
                    </span>

                    <span>
                        {original["refExternalServicePartner"] ? (
                            <>
                                <br />
                                {
                                    original["refExternalServicePartner"][
                                    "sServicePartnerEmail"
                                    ]
                                }
                            </>
                        ) : (
                            "No partner assigned"
                        )}{" "}
                    </span>

                    <span>
                        {original["refExternalServicePartner"] && (
                            <>
                                {original["refExternalServicePartner"][
                                    "sMobileNumber"
                                ] && (
                                        <>
                                            <br />
                                            {
                                                original[
                                                "refExternalServicePartner"
                                                ]["sMobileNumber"]
                                            }
                                        </>
                                    )}
                            </>
                        )}
                    </span>
                    <br></br>

                    <button
                        type="button con"
                        className={`lpm-cons-btns-filled ${original["refFacilitator"] &&
                            original["refFacilitator"]["email"] === user.email
                            ? ""
                            : "disable"
                            } 
                            ${original?.nPackageInstanceId === null && original["refExternalServicePartner"] &&
                            original?.refExternalServicePartner?.sServicePartnerEmail === 'gijare@deasra.co.in' && original?.sPaymentReceiver === 'Partner' 
                            ? "disable"
                            : ""
                            } 
                            ${original?.nPackageInstanceId !== null && (original?.sPackageOfferTitle ==='Long Term Engagement Package' || original?.sPackageOfferTitle ==='Long Term Engagement Package1') && original["refExternalServicePartner"] &&
                            original?.refExternalServicePartner?.sServicePartnerEmail === 'gijare@deasra.co.in' && original?.sPaymentReceiver === 'Partner' 
                            ? "disable"
                            : ""
                            } 
                            ${original["refCurrentState"]["sServiceState"] === "Delivered" || original["refCurrentState"]["sServiceState"] === "Cancelled" ? "disable" : ""}
                            `}
                        onClick={(f) =>
                            props.toggleExternalServicePartnerModal(original)
                        }
                    >
                        ReAssign
                    </button>
                    {/* <br></br> */}



                    <button
                        type="button "
                        className={`lpm-cons-btns-bordered-filter ${original["refExternalServicePartner"]
                            ? ""
                            : "disable"
                            } ${original["refFacilitator"] &&
                                original["refFacilitator"]["email"] === user.email
                                ? ""
                                : "disable"
                            }
                            ${original["refCurrentState"]["sServiceState"] === "Delivered" || original["refCurrentState"]["sServiceState"] === "Cancelled" ? "disable" : ""}
                            `}
                        onClick={(f) =>
                            props.saveExternalServicePartner(original, true)
                        }
                    >
                        Clear
                    </button>


                </>
            )
        },

        {
            id: " ",
            headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
            style: { 'whiteSpace': 'unset' },
            Header: "Know More",
            accessor: " ",
            width: 105,
            //height:10,
            Cell: ({ original }) =>
                original["sServiceCode"] ? (
                    <div className="col">
                        <div className="search-by con-cursor-pointer"
                            onClick={() => {
                                props.onKnowMoreClick(original);
                                // localStorage.setItem("Number", original.sContactNumber)
                            }}
                        >

                            <img
                                alt=""
                                src={group}
                                height={"12px"}
                                width={"30px"}
                                className="conv-mr10"
                            />
                        </div>
                        {
                            props.isSearchByDropdownOpen && props.selectedServiceForKnowMore && props.selectedServiceForKnowMore.nResourceInstanceId === original.nResourceInstanceId &&
                            <div id={original.sEmailAddress} className="spm-searches-by" ref={props.SearchDropdownRef}>
                                <ShowMoreDropdown
                                    isOpen={props.isSearchByDropdownOpen}
                                    toggleSelection={props.selectSearchBySelection}
                                    toggleNotesModal={props.toggleNotesModal}
                                    toggleShowFeedbackModal={props.toggleShowFeedbackModal}
                                    selectedServiceForKnowMore={props.selectedServiceForKnowMore}
                                    sContactNumber={original.sContactNumber}
                                //checkboxItemsList={props.SearchByDropdownList}								
                                />
                            </div>
                        }
                    </div>
                ) : (
                    <span></span>
                ),
        },



    ];


    // const handleRowExpanded = (newExpanded, index, event) => {
    //     setExpanded({
    //         expanded: {[index]: true}
    //       });
    // }

    const handleCreateNewServiceBtn = (ele) => {
        try {
            setIsLoading(true)
            let payload = {
                api_key: "r54B?rHXUE7v%$9t",
                nPackageInstanceId: ele.nPackageInstanceId
            }

            const { tempCreateNew } = api.createNewServiceApi(payload)
                .then(({ data }) => {
                    if (data.ErrorCode === 200) {
                        setNewServiceRequestId(data.data.entry_id)
                        setIsLoading(false)
                        toast(data.Message,
                            {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            });
                    } else {
                        toast(data.Message,
                            {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            });

                            setIsLoading(false)

                        let payload = {
                            nResourceInstanceId: ele.nResourceInstanceId,
                            error_details: data.Message
                        }

                        const { tempEmailSend } = api.sendErrorEmail(payload)
                            .then(({ data }) => {
                                console.log("EMAIL", data)
                            })
                    }
                })
        } catch (error) {
            console.log(error)
        }
    }

    const handleCloseBtnClick = (ele) => {
		try {
			let payload = {
				nParentId: ele.nPackageInstanceId
			}

			const { tempCloseService } = api.closeService(payload)
			.then(({data}) => {
				console.log("Closed", data)
				if(data.Result === "Success") {
                    toast("Closed Service Successfully",
                        {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
				}
			})

		} catch (error) {
			console.log(error)
		}
	}


    console.log(colData, ">>>>colData")
    return (
        <>
            {isLoading || props.loader && (
                <>
                    <Spinner className="center" />
                </>
            )}
            <div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">
                <div className="spled-container">
                    <div className={`${isLoading || props.loader && "set-opacity"} service-partner spled-container hide-expander conv-mt70`}>

                        <ReactTableFixedColumns
                            minRows={0}
                            data={colData || []}
                            columns={columns}
                            manual
                            collapseOnDataChange={false}
                            expanded={expanded}
                            onExpandedChange={(newExpanded, index, event, row) => {
                                if (newExpanded[index[0]] === false) {
                                    newExpanded = {}
                                } else {
                                    Object.keys(newExpanded).map(k => {
                                        newExpanded[k] = parseInt(k) === index[0] ? {} : false
                                    })
                                }
                                props.setResourceId(row.original.nResourceInstanceId)
                                setExpanded(newExpanded)
                                setNewServiceRequestId()
                                // verifiedStatus(row.original)
                            }}
                            defaultPage={props.page}
                            pages={props.pages}
                            page={props.page}
                            pageSize={props.pageSize}
                            sortable={false}
                            defaultPageSize={10}
                            showPagination={true}
                            pageSizeOptions={[10, 20, 30, 50, 75, 100]}
                            onFetchData={(state, instance) => {
                                    if(state?.pageSize?.value){
                                        props.onFetchServiceRequests(instance, false, state?.pageSize?.value);
                                    }else{
                                        props.onFetchServiceRequests(instance, false);
                                    }
                            }}
                            onPageSizeChange={props.onPageSizeOptionChange}
                            PaginationComponent={Pagination}
                            style={{ overflowY: "initial", height: "800px" }}
                            className="-striped hide-scrollbar overflowcss"
                            getTdProps={(state, rowInfo, column, instance) => {
                                if (rowInfo && rowInfo.original) {
                                    const isCouponApplied =rowInfo.original.sCouponCode === "JPMCCOMPLAINCEGST100" && rowInfo.original.fDiscountAmount === rowInfo.original.fAmountFull;
                                    return {
                                        style: {
                                            backgroundColor: isCouponApplied ? '#FFC1CC' : ''
                                        }
                                    };
                                }
                                return {};
                            }}
                            SubComponent={row => {
                                // console.log("row data:::::", row.original)
                                // getBookedSlot(row.original.nResourceInstanceId)
                                getBookedSlot(props.extendedData.nResourceInstanceId)
                                // verifiedStatus(row.original)
                                return (
                                    <div className="row conv-pt20 conv-pl15 conv-bg-f8f8f8 conv-mr0"
                                        onClick={(e) => {
                                            // e.stopPropagation()
                                            localStorage.removeItem("Resource")
                                            if (props.extendedData["refExternalServicePartner"]) {
                                                localStorage.setItem("InstanceID", props.extendedData.nResourceInstanceId)
                                                localStorage.setItem("Resource", props.extendedData["refExternalServicePartner"]["sName"])
                                                // setTimeout(() => {
                                                //     localStorage.removeItem("Resource")
                                                // },5000)
                                            }
                                        }}
                                    // onClick={(() => {
                                    //     localStorage.setItem("ResourceID",props.extendedData["nResourceInstanceId"])
                                    //     localStorage.setItem("Expert", props.extendedData["refExternalServicePartner"]["sName"])
                                    // })}
                                    >
                                        <div className="col-12 ">
                                            {/* <span className="spled-info-title">Information</span> */}
                                            <div className="row conv-pb12">
                                                <div className="col-5 conv-ml90 conv-mr60 conv-pl98">
                                                    <span className="spled-info-title">Information</span>
                                                    <div className="row conv-pb10 conv-pt10 ">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Progressed on date</span>
                                                        </div>
                                                        <div className="col-6">
                                                            {/* <span className="spled-black-text">{moment(
                                                                moment.utc(props.extendedData.dtServiceProgression).toDate()
                                                            ).format("Do MMMM YYYY h:mm:ss a")} </span> */}
                                                            <span className="spled-black-text">{props.progressionDate ? moment(
                                                                moment.utc(props.progressionDate).toDate()
                                                            ).format("Do MMMM YYYY h:mm:ss a") : props.extendedData.dtServiceProgression ? moment(
                                                                moment.utc(props.extendedData.dtServiceProgression).toDate()
                                                            ).format("Do MMMM YYYY h:mm:ss a") : ''} </span>
                                                        </div>
                                                    </div>

                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Facilitator Assigned On</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">
                                                                {moment(moment.utc(props.extendedData.dtRequested).toDate()).format("Do MMMM YYYY h:mm:ss a")}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Device Type</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.sDeviceType}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Payment Status</span>
                                                        </div>
                                                        <div className="col-6">
                                                            {/* <span className="spled-black-text">{props.extendedData.sPaymentStatus ? props.extendedData.sPaymentStatus : "NA"}</span> */}
                                                            <span className="spled-black-text">
                                                                {
                                                                    props.extendedData.sPaymentMode == '1_Step_Payment'
                                                                        ? (
                                                                            props?.extendedData?.sPaymentStatus
                                                                                ? (
                                                                                    props.extendedData.sPaymentStatus == 'Payment Link Deactivated'
                                                                                        ? 'Credit'
                                                                                        : props.extendedData.sPaymentStatus
                                                                                )
                                                                                : "NA"
                                                                        )
                                                                        : (
                                                                            props.extendedData.fDiscountAmount > props.extendedData.fAmountFirst
                                                                                ? (
                                                                                    props?.extendedData?.sPaymentStatus
                                                                                        ? (
                                                                                            props.extendedData.sPaymentStatus == 'Payment Link Deactivated'
                                                                                                ? 'Credit'
                                                                                                : props.extendedData.sPaymentStatus
                                                                                        )
                                                                                        : "NA"
                                                                                )
                                                                                : (
                                                                                    props?.stateAuditLog?.some(
                                                                                        item => item.refCurrentState === "Full Payment Received"
                                                                                    )
                                                                                        ? "Credit"
                                                                                        : (
                                                                                            props?.stateAuditLog?.some(
                                                                                                item => item.refCurrentState == "Full Payment Requested"
                                                                                            ) && props?.extendedData?.sPaymentStatus
                                                                                                ? props.extendedData.sPaymentStatus
                                                                                                : "NA"
                                                                                        )
                                                                                )
                                                                        )
                                                                }

                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Payment Link</span>
                                                        </div>
                                                        <div className="col-6">
                                                        <p>
                                                            {
                                                                props.extendedData?.urlPayment &&  props.extendedData?.refCurrentState?.sServiceState !== "Full Payment Received" && props.extendedData?.refCurrentState?.sServiceState !== "Delivered" && props.extendedData?.refCurrentState?.sServiceState !== "Cancelled" ? (
                                                                    <>
                                                                        <img
                                                                            alt="copy"
                                                                            title="Copy Payment Link"
                                                                            src={copysvg}
                                                                            height={"20px"}
                                                                            width={"16px"}
                                                                            className="con-cursor-pointer conv-mr13 conv-ml10"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                            
                                                                                if(props.extendedData.urlPayment){
                                                                                    copyToClipboard(props.extendedData.urlPayment);
                                                                                    toast(`Payment Link Copied!`, {
                                                                                        autoClose: 5000,
                                                                                        type: toast.TYPE.SUCCESS,
                                                                                    });
                                                                                }else{
                                                                                    toast(`No payment link found`, {
                                                                                        autoClose: 5000,
                                                                                        type: toast.TYPE.ERROR, // Use ERROR instead of SUCCESS
                                                                                    });
                                                                                }
                                                                            }}
                                                                        /> 
                                                                        {/* <small>(copy payment link)</small> */}
                                                                    </>
                                                                ) : ""
                                                            }
                                                        </p>

                                                        </div>
                                                    </div>
                                                    {
                                                        props.extendedData.sSpeakerName != null ?
                                                        <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Speaker</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">
                                                                {props.extendedData.sSpeakerName}
                                                                {props.extendedData.sSpeakerOrganization ? (" (" + props.extendedData.sSpeakerOrganization + ")") : ""}
                                                                    </span>
                                                        </div>
                                                    </div>
                                                            :
                                                            ""
                                                    }
                                                    

                                                    <span className="spled-info-title">Business Detail</span>
                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Business Name</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.sBusinessName}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Business Name</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData?.refBusinessSectorNew?.sSectorName}</span>
                                                        </div>
                                                    </div>
                                                    {/* Verification Status Implementation */}
                                                    {/* {
                                                        props.extendedData.sServiceCode === "DEPRELISTING" ? 
                                                            
                                                            <div className="row conv-pb10 conv-pt10">
                                                            <div className="col-6">
                                                                <span className="spled-colored-label">Verified</span>
                                                            </div>
                                                            <div className="col-6">
                                                                        <span className="spled-black-text">{verified ? verified : "No"}</span>
                                                            </div>
                                                        </div>
                                                                : 
                                                                ""
                                                    } */}
                                                    {
                                                        // props.extendedData.refExternalServicePartner["sName"] === "Mr. Sudhir Gijare" ||
                                                        //     props.extendedData.refExternalServicePartner["sName"] === "Leena Khandekar" ||
                                                        //     props.extendedData.refExternalServicePartner["sName"] === "Cdr Sanjeev Deshpande" ||
                                                        //     props.extendedData.refExternalServicePartner["sName"] === "Smita Deshpande" ||
                                                        //     props.extendedData.refExternalServicePartner["sName"] === "Kavita - Rahul Awasthi" ?
                                                        props.extendedData.sServiceCode === "LTEXP"
                                                            || props.extendedData.sServiceCode === "LTEXPCOACH"
                                                            || props.extendedData.sServiceCode === "EXPRTCONSULT"
                                                            || props.extendedData.sServiceCode === "GRPEXPRTCONSULT"
                                                            ?
                                                            <>
                                                                <div className="row conv-pb10 conv-pt10">
                                                                    <div className="col-6">
                                                                        <span className="spled-colored-label"></span>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <span className="spled-black-text"> <small className="underlined-action spled-colored-label" onClick={openCalenderModalIsTrue}>View Expert Calendar</small> </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row conv-pb10 conv-pt10">
                                                                    <div className="col-6">
                                                                        <span className="spled-colored-label"></span>
                                                                    </div>
                                                                    {
                                                                        // props.extendedData["refCurrentState"]["sServiceState"] != "Delivered" ? 
                                                                        props.extendedData.refExternalServicePartner ? 

                                                                        arr.includes(props.extendedData.refExternalServicePartner["sName"])
                                                                            ?
                                                                            (<div className="col-6">
                                                                                <small className={`underlined-action spled-colored-label
                                                                                ${(props.extendedData["refCurrentState"]["sServiceState"] === "Delivered" || props.extendedData["refCurrentState"]["sServiceState"] === "Cancelled") || (AppData != undefined && AppData.status === null) ? "disable" : ''}`} onClick={() => {
                                                                                        setModalIsOpenToTrue()
                                                                                        localStorage.setItem("InstanceID", props.extendedData.nResourceInstanceId)
                                                                                        getDatabyID()
                                                                                    }}>  Create Appointment</small>
                                                                            </div>)
                                                                            :
                                                                            (<div className="col-6">
                                                                                <small className="underlined-action spled-colored-label" style={{
                                                                                    pointerEvents: "none",
                                                                                    opacity: "0.4"
                                                                                }}>  Create Appointment</small>
                                                                            </div>)
                                                                            :
                                                                            (<div className="col-6">
                                                                                <small className="underlined-action spled-colored-label" style={{
                                                                                    pointerEvents: "none",
                                                                                    opacity: "0.4"
                                                                                }}>  Create Appointment</small>
                                                                            </div>)
                                                                        // :
                                                                        // (<div className="col-6">
                                                                        //     <small className="underlined-action spled-colored-label" style={{
                                                                        //         pointerEvents: "none",
                                                                        //         opacity: "0.4"
                                                                        //     }}>  Create Appointment</small>
                                                                        // </div>)
                                                                    }
                                                                    {/* {AppData != undefined ?
                                                                        <>
                                                                            <br />
                                                                            <span className="my-services-model-key">Booked Slot:</span>
                                                                            <span className="my-services-model-value conv-ml10">{AppData.slot_day},</span>
                                                                            <span className="my-services-model-value conv-ml5">{AppData.slot_time},</span>
                                                                            <span className="my-services-model-value conv-ml5">{AppData.bookdate}</span>

                                                                        </>
                                                                        : ""} */}
                                                                </div>
                                                                {
                                                                    (AppData != undefined && AppData.status === null) && props.extendedData["refCurrentState"]["sServiceState"] != "Delivered"?
                                                                        <div className="row conv-pb10 conv-pt10">
                                                                            <div className="col-6">
                                                                                <span className="spled-colored-label">Booked Slot</span>
                                                                            </div>
                                                                            <div className="col-6">
                                                                            <span className="spled-black-text">{AppData.bookdate},{AppData.slot_day},{AppData.slot_time}</span>
                                                                                {

                                                                                    AppData.bookdate < CurrentDate || (AppData.bookdate === CurrentDate && bookTime < timeRN) ? 
                                                                                    <span className="spled-black-text ml-3">Time Up</span> :
                                                                                    <span className="ml-2" onClick={deleteAppointment}><small className="underlined-action spled-colored-label">Cancel slot</small></span>
                                                                                }
                                                                                
                                                                                
                                                                            </div>
                                                                        </div>
                                                                        :    
                                                                        
                                                                        ""

                                                                        // :
                                                                        // isSlot && props.extendedData["refCurrentState"]["sServiceState"] != "Delivered"? 
                                                                        // <div className="row conv-pb10 conv-pt10">
                                                                        //     <div className="col-6">
                                                                        //         <span className="spled-colored-label">Booked Slot</span>
                                                                        //     </div>
                                                                        //     <div className="col-6">
                                                                        //     <span className="spled-black-text">{bookSlotDate},{bookSlotDay},{bookSlotTime}</span>
                                                                        //         {

                                                                        //             AppData.bookdate < CurrentDate || (AppData.bookdate === CurrentDate && bookTime < timeRN) ? 
                                                                        //             <span className="spled-black-text ml-3">Time Up</span> :
                                                                        //             <span className="ml-2" onClick={() => {
                                                                        //                 deleteAppointment()
                                                                        //                 setIsSlot(false)
                                                                        //             }}><small className="underlined-action spled-colored-label">Cancel slot</small></span>
                                                                        //         }
                                                                                
                                                                                
                                                                        //     </div>
                                                                        // </div>
                                                                        // : 
                                                                        // ""
                                                                        
                                                                }

                                                            </>
                                                            : ""
                                                    }

                                                    {
                                                        newServiceRequestId && 
                                                        <div className="row conv-pb10 conv-pt10">
                                                                    <div className="col-6">
                                                                    <div style={{backgroundColor: '#78417C', padding: 10}}>

<span className="spled-info-title" style={{color: "#fff"}}>New Service Id</span>
    <span className="spled-colored-label" style={{color: "#fff"}}> {newServiceRequestId}
    <img
        alt="copy"
        src={copysvg1}
        height={"20px"}
        width={"16px"}
        // style={{marginLeft: 10}}
        className="con-cursor-pointer conv-mr13 conv-ml10"
        onClick={(e) => {
            e.preventDefault();
            copyToClipboard(newServiceRequestId);
            toast(`${newServiceRequestId} Copied!`, {
                autoClose: 5000,
                type: toast.TYPE.SUCCESS,
            });
        }}
    />
     </span>
     </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                    
                                                                    </div>
                                                                </div>
                                                    }

                                                    {
                                                        (props.extendedData.sPackageOfferTitle === "Long Term Engagement Package" || props.extendedData.sPackageOfferTitle === "Long Term Engagement Package1") &&
                                                        props.extendedData["refCurrentState"]["sServiceState"] != "Delivered" &&
                                                        props.extendedData["refCurrentState"]["sServiceState"] != "Cancelled" &&
                                                        <div className="row conv-pb10 conv-pt10">
                                                            <div className="col-6">
                                                                <button
                                                                    type="button"
                                                                    className="my-services-model-submit-btn conv-mr15"
                                                                    disabled={isLoading}
                                                                    onClick={() => handleCreateNewServiceBtn(props.extendedData)}
                                                                >
                                                                    Create New Service
                                                                </button>
                                                            </div>
                                                        </div>
                                                    }

                                                    {/* {
                                                        props.extendedData.sPackageOfferTitle &&
                                                        props.extendedData["refCurrentState"]["sServiceState"] != "Delivered" &&
                                                        props.extendedData["refCurrentState"]["sServiceState"] != "Cancelled" &&
                                                        <div className="row conv-pb10 conv-pt10">
                                                            <div className="col-6">
                                                                <button
                                                                    type="button"
                                                                    className="my-services-model-cancel-btn conv-mr15"
                                                                    onClick={() => handleCloseBtnClick(props.extendedData)}
                                                                    disabled={isLoading}
                                                                >
                                                                    Close Service
                                                                </button>
                                                            </div>
                                                        </div>
                                                    } */}


                                                    {/* <div>
                                                             <div style={{
                                                                display: 'flex'
                                                            }}>
                                                                <div className="col-6">
                                                                    <label className="my-services-model-value">Select Appointment Date: </label>
                                                                    <DatePicker selected={startDate}
                                                                        dateFormat="dd/MM/yyyy" onChange={(date) => setStartDate(date)} minDate={new Date()} width="300px" />

                                                                </div>

                                                                <div className="col-6">
                                                                    <label className="my-services-model-value">Select Appointment Time: </label>
                                                                    <Select
                                                                    styles={{
                                                                        width: "30%",
                                                                        // Fixes the overlapping problem of the component
                                                                        menu: provided => ({ ...provided, zIndex: 3 })
                                                                    }}
                                                                        className='react-select-container'></Select>
                                                                </div>

                                                            
                                                            </div>
                                                            <Button>Book Appointment</Button>
                                                            </div> */}





                                                </div>
                                                <div className="col-5 conv-ml40 conv-pl50">
                                                    <span className="spled-info-title">EHH Details</span>
                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Entry Point</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.sEntryPoint ? " " : "NA"}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">EHH Email</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.sExternalHHEmail ? " " : "NA"}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">EHH Contact No</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.sEhhContactNumber ? " " : "NA"}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">EHH Org:</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.sEhhOrg ? " " : "NA"}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Stay Engaged with EHH</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.bStayEngagedWithEhh ? "Yes" : "No"}</span>
                                                        </div>
                                                    </div>

                                                    <span className="spled-info-title">Coupon Detail</span>
                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Coupon Applied</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.bCouponApplied ? "Yes" : "No"}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Coupon Code</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.sCouponCode ? props.extendedData.sCouponCode : "NA"}</span>
                                                        </div>
                                                    </div>

                                                    <div className="row conv-pb10 conv-pt10">
                                                        <div className="col-6">
                                                            <span className="spled-colored-label">Coupon Discount Amount</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <span className="spled-black-text">{props.extendedData.fDiscountAmount ? props.extendedData.fDiscountAmount : "NA"}</span>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                );
                            }}

                        />

                        <Modal isOpen={newModal}>
                            <ModalContent className="medium-general-modal">
                                <div className="modal-header">
                                    <span className="modal-title">Expert Calender</span>
                                    <img
                                        alt="close"
                                        id="Close"
                                        src={close_modal}
                                        className="close modal-close"
                                        onClick={openCalenderModalIsFalse}
                                    />
                                </div>

                                <div className="modal-body">
                                    <div>
                                        <span className="spled-info-title conv-pb10 conv-pt10">Availability for Engagement with DeAsra</span>
                                        <ReactTableFixedColumns
                                            minRows={0}
                                            data={ExpertPartner}
                                            columns={expertColumns}
                                            style={{ overflowY: "initial", height: "400px" }}
                                            className="-striped hide-scrollbar overflowcss"
                                        />
                                    </div>

                                </div>
                            </ModalContent>
                        </Modal>

                        <Modal isOpen={modalIsOpen}>
                            <ModalContent className="general-modal">
                                <div className="modal-header">
                                    <span className="modal-title">Book an Expert Appointment</span>
                                    <img
                                        alt="close"
                                        id="Close"
                                        src={close_modal}
                                        className="close modal-close"
                                        onClick={() => {
                                            setStartDate(new Date)
                                            localStorage.removeItem("Resource")
                                            setModalIsOpenToFalse()
                                        }
                                        }
                                    />
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <span className="spled-colored-label" style={{ padding: '15px' }}>Expert Name :</span> <span className="spled-info-title">{ExpertName}</span>
                                        {/* <div>
                                            <span className="spled-colored-label" style={{ padding: '15px' }}> Request ID: </span> <span className="spled-black-text">2</span>
                                        </div> */}
                                        <div>
                                            <span className="spled-colored-label" style={{ padding: '15px' }}> Expert ID: </span> <span className="spled-black-text">{ExpertID}</span>
                                        </div>
                                        <div style={{
                                            display: 'flex'
                                        }}>
                                            <div className="row container">
                                                <div className="col-6">
                                                    <label className="my-services-model-value" style={{
                                                        marginTop: '25px'
                                                    }}>Book Appointment Date: </label>
                                                    <DatePicker selected={startDate}
                                                        dateFormat="dd/MM/yyyy" onChange={(date) => {
                                                            // let payloadDate1 = date.toLocaleDateString('en-CA')
                                                            var getYear = date.toLocaleString("default", { year: "numeric" });
                                                            var getMonth = date.toLocaleString("default", { month: "2-digit" });
                                                            var getDay = date.toLocaleString("default", { day: "2-digit" });
                                                            var payloadDate1 = getYear + "-" + getMonth + "-" + getDay;
                                                            setPayloadDate(payloadDate1)
                                                            console.log("PayloadDate==", payloadDate)
                                                            setStartDate(date)
                                                            console.log("NewDate==", startDate)
                                                            setExpertDay("")
                                                            setExpertTime("")
                                                        }} minDate={new Date()} width="300px" />

                                                </div>

                                                <div className="col-6" >
                                                    <label className="my-services-model-value" style={{
                                                        marginTop: '25px',
                                                        textAlign: 'center'
                                                    }}>Book Appointment Day: </label>
                                                    {/* <Select
                                                            styles={{
                                                                width: "50%",
                                                                // Fixes the overlapping problem of the component
                                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                            }}
                                                            options={[{ label: day, value: day }]}
                                                            className='react-select-container'
                                                            onChange={(e) => {
                                                                setExpertDay(e.value)
                                                            }}></Select> */}
                                                    {/* <select style={{
                                                        width: "65%",
                                                        height: '35px',
                                                        padding: '5px'
                                                    }}
                                                        // onChange={({ target }) => {
                                                        //     setExpertTime(target.value)
                                                        // }}
                                                        // value={expertTime}
                                                        required
                                                    >
                                                        <option value={day} selected disabled hidden>{day}</option>
                                                    </select> */}
                                                    <input type="text" value={day} style={{
                                                        opacity: "0.4",
                                                        pointerEvents: "none",
                                                        width: "65%",
                                                        height: '40px',
                                                        padding: '5px'
                                                    }} />
                                                </div>

                                                {/* <div className="col-6">
                                                    <label className="my-services-model-value" style={{
                                                        marginTop: '25px'
                                                    }}>Book Appointment Time: </label>
                                                    <br />
                                                     <Select
                                                        styles={{
                                                            width: "30%",
                                                            color: 'blue',
                                                            // Fixes the overlapping problem of the component
                                                            menu: provided => ({ ...provided, zIndex: 3 })
                                                        }}
                                                        options={timeSlot.map((ele) => {
                                                           return [{ label: ele, value: ele }]
                                                        }
                                                        )}
                                                        className='react-select-container'
                                                        onChange={(e) => {
                                                            setExpertTime(e.label)
                                                        }}></Select> 
                                                        <select style={{
                                                            width: "65%",
                                                        }} 
                                                        onChange={({target}) => {
                                                            setExpertTime(target.value)
                                                        }}
                                                        // value={expertTime}
                                                        >
                                                            <option value="none" selected disabled hidden>Select an Option</option>
                                                            {
                                                                timeSlot.map((ele,id) => {
                                                                    return <option key= {id}>{ele}</option>
                                                                })
                                                            }
                                                        </select>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="row container">
                                            {/* <div className="col-12" style={{
                                                        marginLeft: '15px'
                                                    }}>
                                                        <label className="my-services-model-value" style={{
                                                            marginTop: '25px',
                                                            textAlign: 'center'
                                                        }}>Book Appointment Day: </label>
                                                        <Select
                                                            styles={{
                                                                width: "50%",
                                                                // Fixes the overlapping problem of the component
                                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                            }}
                                                            options={[{ label: day, value: day }]}
                                                            className='react-select-container'
                                                            onChange={(e) => {
                                                                setExpertDay(e.value)
                                                            }}></Select>
                                                    </div> */}
                                            <div className="col-6">
                                                <label className="my-services-model-value" style={{
                                                    marginTop: '25px'
                                                }}>Book Appointment Time: </label>
                                                <br />
                                                {/* <Select
                                                        styles={{
                                                            width: "30%",
                                                            color: 'blue',
                                                            // Fixes the overlapping problem of the component
                                                            menu: provided => ({ ...provided, zIndex: 3 })
                                                        }}
                                                        options={timeSlot.map((ele) => {
                                                           return [{ label: ele, value: ele }]
                                                        }
                                                        )}
                                                        className='react-select-container'
                                                        onChange={(e) => {
                                                            setExpertTime(e.label)
                                                        }}></Select> */}
                                                <select style={{
                                                    width: "65%",
                                                    height: '40px',
                                                    padding: '5px'
                                                }}
                                                    onChange={({ target }) => {
                                                        setExpertTime(target.value)
                                                    }}
                                                    value={expertTime ? expertTime : "new"}
                                                >
                                                    <option value="new" selected disabled>Select an Option</option>
                                                    {
                                                        timeSlot.map((ele, id) => {
                                                            return <option key={id}>{ele}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-6" style={{
                                                // marginLeft : '10px'
                                            }}>
                                                <label className="my-services-model-value" style={{
                                                    marginTop: '25px',
                                                    textAlign: 'center',
                                                }}>Comments: </label>
                                                <textarea
                                                    name="commentsAdded"
                                                    className="w-100 h-50 form-control rounded"
                                                    // value={serviceRequestEditableData.sFollowupNotes}
                                                    onChange={(e) => {
                                                        setCommentsText(e.target.value)
                                                    }}
                                                // style={{ minHeight: "80px", maxHeight: "80px" }}
                                                />
                                            </div>
                                        </div>





                                        <div style={{
                                            margin: '10px',
                                            textAlign: 'center'
                                        }}>
                                            <Button className="text-center" onClick={() => {

                                                bookExpert()
                                            }}>Book Appointment</Button>
                                        </div>
                                    </div>
                                </div>

                            </ModalContent>
                        </Modal>


                        <NotesServiceFacilitatorModal
                            auditTrail={props.auditTrail}
                            changeSelectedNotesDetails={props.changeSelectedNotesDetails}
                            notesHistory={props.notesHistory}
                            notesDetails={props.notesDetails}
                            isOpen={props.showNotesModal}
                            toggleModal={props.toggleNotesModal}
                            onInputChange={props.onNotesChange}
                            onSaveNotesDetails={props.onSaveNotesDetails}
                            isOpenConfirmationModal={props.showConfirmationModalNotes}
                            toggleConfirmationModal={props.toggleConfirmationModalNotes}
                            confirmChangeNotes={props.confirmChangeNotes}
                            /*Need to talk to SP */
                            needToTalkToSPOptions={props.needToTalkToSPOptions}
                            selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
                            setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
                            //service={props.selectedServiceRequest}
                            onUpdateNeedToTalkToSPFlag={props.onUpdateNeedToTalkToSPFlag}
                            /*End*/

                            //Offline meet
                            offlinemeetoptions={props.offlinemeetoptions}
                            selectedofflinemeetoptions={props.selectedofflinemeetoptions}
                            setselectedofflinemeetoptions={props.setselectedofflinemeetoptions}
                            service={props.selectedServiceRequest}
                            onUpdateOfflineMeetoptions={props.onUpdateOfflineMeetoptions}
                        //End
                        />
                        <AssignServicePartnerModal
                            isOpen={props.showServicePartnerModal}
                            toggleModal={props.toggleServicePartnerModal}
                            currentServicePartner={props.currentServicePartner}
                            servicePartnerList={props.servicePartnerList}
                            saveServicePartner={props.saveServicePartner}
                            toggleServicePartner={props.toggleServicePartner}
                        />
                        <AssignExternalServicePartnerModalNew
                            isLoading={props.isLoading}
                            isOpen={props.showExternalServicePartnerModal}
                            toggleModal={props.toggleExternalServicePartnerModal}
                            currentServicePartner={props.currentExternalServicePartner}
                            servicePartnerList={props.externalServicePartnerList}
                            saveServicePartner={props.saveExternalServicePartner}
                            toggleServicePartner={props.toggleExternalServicePartner}
                            deleteAppointment={deleteAppointment}
                        />
                        {/* <ConfirmationModal
                                message="Are you sure about changing the status?"
                                isOpen={showConfirmationModal}
                                toggleModal={props.toggleConfirmationModal}
                                changeState={props.changeState}
                                /> */}
                        <StateServiceChangeModalSPM
                            isLoading={props.isLoadingStateChange}
                            service={props.selectedServiceRequest}
                            handleClick={handleClick}
                            isOpen={showStatusChangeModal}
                            toggleModal={toggleStatusChangeModal}
                            showConfirmationModal={showConfirmationModal}
                            toggleConfirmationModal={toggleConfirmationModal}
                            /**NEFT Modal */
                            isLoadingNEFT={props.isLoadingNEFT}
                            isNeftModalOpen={props.isNeftModalOpen}
                            toggleNeftModal={props.toggleNeftModal}
                            neftDetails={props.neftDetails}
                            onNeftDetailsChanged={props.onNeftDetailsChanged}
                            onSaveNeftDetails={props.onSaveNeftDetails}
                            /** */
                            sendPaymentLink={props.sendPaymentLink}
                            message="Are you sure about changing the status?"
                            isOpenConfirmation={showConfirmationModal}
                            toggleModalConfirmation={toggleConfirmationModal}
                            changeState={changeState}
                            /** Cancellation reason modal*/
                            toggleCancellationReasonModal={
                                props.toggleCancellationReasonModal
                            }
                            showSendNeftDetailsModal={props.showSendNeftDetailsModal}
                            setShowSendNeftDetailsModal={props.setShowSendNeftDetailsModal}

                            /**Refund Modal */
                            isLoadingRefund={props.isLoadingRefund}
                            isRefundModalOpen={props.isRefundModalOpen}
                            toggleRefundModal={props.toggleRefundModal}
                            refundDetails={props.refundDetails}
                            onRefundDetailsChanged={props.onRefundDetailsChanged}
                            onSaveRefundDetails={props.onSaveRefundDetails}
                            cancellationReasonDropdownOptions={props.cancellationReasonDropdownOptions}
                            onSelectCancellationReasonforRefund={props.onSelectCancellationReasonforRefund}
                            selectedCancellationReasonforRefund={props.selectedCancellationReasonforRefund}
                            enableOtherDescriptionTextboxforRefund={props.enableOtherDescriptionTextboxforRefund}
                            cancellationReasonOtherDescriptionforRefund={props.cancellationReasonOtherDescriptionforRefund}
                            onChangeCancellationReasonOtherDescriptionforRefund={props.onChangeCancellationReasonOtherDescriptionforRefund}
                            /** */

                            stateAuditLog={props.stateAuditLog}


                        />
                        <CancellationReasonModal
                        isLoading={props.isLoadingStateChange}
                            isDisabled={props.enableCancelButtonFlag}
                            isOpen={props.showCancellationReasonModal}
                            toggleModal={props.toggleCancellationReasonModal}
                            cancellationReasonDropdownOptions={
                                props.cancellationReasonDropdownOptions
                            }
                            onSelectCancellationReason={props.setSelectedCancellationReason}
                            selectedCancellationReason={props.selectedCancellationReason}
                            enableOtherDescriptionTextbox={
                                props.enableOtherDescriptionTextbox
                            }
                            cancellationReasonOtherDescription={
                                props.cancellationReasonOtherDescription
                            }
                            onChangeCancellationReasonOtherDescription={
                                props.onChangeCancellationReasonOtherDescription
                            }
                            onChangeState={changeState}
                        ></CancellationReasonModal>
                        <StateChangeLogModalSPM
                            isOpen={showStatusChangeLogModal}
                            toggleModal={toggleStatusChangeLogModal}
                            stateAuditLog={props.stateAuditLog}
                        ></StateChangeLogModalSPM>

                        <ShowMoreDropdown

                            isOpen={props.isSearchByDropdownOpen}
                            toggleSelection={props.selectSearchBySelection}

                        />

                        {/* <UserFacilitatorFeedbackModal
                                //facilitatorActionView={props.facilitatorActionView}
                                //notesDetails={props.selectedFacilitatorAction}
                                isOpen={props.showFeedbackModal}
                                toggleModal={props.toggleShowFeedbackModal}
                                
                                /> */}
                    </div>
                </div>
            </div>

        </>
    );
}
